export function track(eventNameOrProps: string) {
  window.dataLayer?.push(
    typeof eventNameOrProps === "string"
      ? { event: eventNameOrProps }
      : eventNameOrProps
  );
}
